import { Component, Fragment, useMemo } from 'react';
import { connect, useSelector } from 'react-redux';
import { APP_STATUS } from 'ContentEditorUI/redux/constants';
// @ts-ignore not yet typed
import AsyncComponentContext from 'ContentEditorUI/context/AsyncComponentContext';
import FetchAndCorrectPageSlugContainer from 'page-editor-ui/containers/FetchAndCorrectPageSlugContainer';
// @ts-ignore not yet typed
import { renderFeedbackLoader, Surveys } from 'ContentEditorUI/lib/csatSurvey';
import { createTracker } from 'usage-tracker';
import { withSessionReplay } from 'usage-tracker-session-replay';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
// @ts-ignore not yet typed
import GlobalContentModal from 'ContentEditorUI/components/modals/GlobalContentModal';
import EmbedModal from 'ContentEditorUI/components/modals/EmbedModal';
import ContentRoutes from 'ContentUtils/Routes';
// @ts-ignore not yet typed
import LockedModal from 'ContentEditorUI/components/modals/LockedModal';
import { requestFailedOrUninitialized, requestUninitialized } from 'redux-request-state/util/requestStateCheckers';
import events from 'page-editor-ui/events.yaml';
import { getCanSetDynamicPages } from 'page-editor-ui/redux/selectors/pageSettingsSelectors';
// @ts-ignore not yet typed
import { getContentTypeNounKey } from 'page-editor-ui/redux/selectors/i18nKeySelectors';
import TemplateExistenceCheckContainer from 'ContentEditorUI/containers/TemplateExistenceCheckContainer';
// @ts-ignore not yet typed
import { getContentTypeName } from 'ContentEditorUI/redux/selectors/contentTypeSelector';
// @ts-ignore not yet typed
import CopyAsHubLContainer from 'ContentEditorUI/components/CopyAsHubLContainer';
import LegacyPageScaffoldingContainer from 'page-editor-ui/containers/LegacyPageScaffoldingContainer';
// @ts-ignore not yet typed
import UpgradableModulePqls from 'page-editor-ui/containers/UpgradableModulePqls';
// @ts-ignore not yet typed
import CloneRequestModalContainer from 'ContentEditorUI/containers/CloneRequestModalContainer';
import { getIsSitePage, getIsLandingPage, getIsBlogListingPage, getCategoryId, getIsContentFlaggedOrViolated } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { fetchCrmObjectTypes, fetchHubDbTables, fetchDataQueries
// @ts-ignore not yet typed
} from 'page-editor-ui/redux/actions/pageSettingsActions';
import { getSubcategory, getHasContentModel, getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
// @ts-ignore not yet typed
import { getRoutingCurrentPage } from 'ContentEditorUI/redux/selectors/routingSelectors';
import { getIsStarterPageTemplateAndNoAdvancedFeaturesAccess } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
// @ts-ignore not yet typed
import { fetchAccountVerificationStatus } from 'ContentEditorUI/redux/actions/accountVerificationStatusActions';
// @ts-ignore not yet typed
import { fetchMultiDomainPublishingScopeChange } from 'ContentEditorUI/redux/actions/portalActions';
// @ts-ignore not yet typed
import { fetchDomainExclusionReason } from 'ContentEditorUI/redux/actions/portalDomainsActions';

// @ts-ignore not yet typed
import { togglePublishOptionsModalOpen as togglePublishOptionsModalOpenAction } from 'ContentEditorUI/redux/actions/appActions';
import { getAppStatus, getIframeReady, getAddModuleSidebarLoaded, getIsAppReadyForSaving } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getHasAnyContainerOrDndAreaToAddModules } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getShouldShowScopesHaveChangedModal } from 'ContentEditorUI/redux/selectors/modalSelectors';
import { getPageLimitRequest, getMlangPagesLimitRequest
// @ts-ignore not yet typed
} from 'page-editor-ui/redux/selectors/pageLimitSelectors';
import { getHasPartnerMatchingAppAccess, getCanUseQuickSpot, getHasLandingPagesMultiLangAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
// @ts-ignore not yet typed
import { fetchBrandColors as fetchBrandColorsAction } from 'ContentEditorUI/redux/actions/brandActions';
import { fetchPageLimit as fetchPageLimitAction, fetchMlangPagesLimit as fetchMlangPagesLimitAction
// @ts-ignore not yet typed
} from 'page-editor-ui/redux/actions/pageLimitActions';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import PageAutoSaveContainer from 'page-editor-ui/containers/PageAutoSaveContainer';
import { autoSaveDebounced as autoSaveDebouncedAction, autoSave as autoSaveAction
// @ts-ignore not yet typed
} from 'page-editor-ui/redux/actions/pageSaveActions';
// @ts-ignore not yet typed
import PatagoniaModalQueryChecker from 'page-editor-ui/containers/PatagoniaModalQueryChecker';
import { getIsUngatedForPatagonia, getIsStagingV2 } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getOpenModal, getRunTestModalOpen } from 'ContentEditorUI/redux/selectors/modalSelectors';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
import { getThemePath } from 'ContentEditorUI/redux/selectors/themeSelectors';
import PageOperationsModalSwitch from './PageOperationsModalSwitch';
import { getShouldShowOnboardingModal } from 'ContentEditorUI/redux/selectors/localCachedSettingsSelectors';
import TriggerWootricCsatSurveyContainer, { WootricSurveyNames } from 'ContentEditorUI/containers/TriggerWootricCsatSurveyContainer';
import { isTourCurrentlyActive } from 'onboarding-tours/util/activeTour';
import MlangLimitUpgradeModal from 'page-editor-ui/components/MlangLimitUpgradeModal';
// @ts-ignore not yet typed
import { CONSUMER_NAME } from 'page-editor-ui/Constants';
import CmsSettingsModals from 'ContentEditorUI/components/modals/CmsSettingsModals';
import { getPageSettingsFullUrl } from '../redux/selectors/pageSettingsSelectors';
import { getStagedPageSandboxDomainName } from '../redux/selectors/urlSelectors';
import { buildSandboxUrl } from '../utils/urlUtils';
import Spotlight from 'page-editor-ui/containers/Spotlight';
import { SectionsLibraryOnboardingTourController } from 'page-editor-ui/components/onboarding/SectionsLibraryOnboardingTour';
import { usePersonalizedPageUrl } from '../hooks/usePersonalizedPageUrl';
import { getHasPersonalizedVariants, getIsPersonalizedVariant } from '../redux/selectors/pageContentModelSelectors';
import { getIsSuggested } from 'ContentEditorUI/redux/selectors/publishSelectors';
import PersonalizationOnboardingBeacons from './PersonalizationOnboardingBeacons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getPageType = (isBlogListingPage, isSitePage) => {
  if (isBlogListingPage) {
    return 'blog-listing-page';
  }
  if (isSitePage) {
    return 'site-page';
  }
  return 'landing-page';
};
const getPersonalizationInfo = ({
  isSuggested,
  isPersonalizedVariant,
  hasPersonalizedVariants
}) => {
  if (isSuggested) {
    if (isPersonalizedVariant) {
      return 'agent-suggested-personalized-variant-page';
    }
    if (hasPersonalizedVariants) {
      return 'agent-suggested-personalized-default-page';
    }
    return 'agent-suggested-page';
  }
  if (isPersonalizedVariant) {
    return 'variant-page';
  }
  if (hasPersonalizedVariants) {
    return 'personalized-default-page';
  }
  return undefined;
};
const mapStateToProps = state => ({
  // @ts-ignore state not yet typed
  appIsReadyForSaving: getIsAppReadyForSaving(state),
  // @ts-ignore state not yet typed
  appStatus: getAppStatus(state),
  // @ts-ignore state not yet typed
  iframeReady: getIframeReady(state),
  // @ts-ignore state not yet typed
  addModuleSidebarLoaded: getAddModuleSidebarLoaded(state),
  hasContentModel: getHasContentModel(state),
  currentPage: getRoutingCurrentPage(state),
  isLandingPage: getIsLandingPage(state),
  isSitePage: getIsSitePage(state),
  // @ts-ignore state not yet typed
  isBlogListingPage: getIsBlogListingPage(state),
  // @ts-ignore state not yet typed
  canSetDynamicPages: getCanSetDynamicPages(state),
  contentNounKey: getContentTypeNounKey(state),
  contentTypeName: getContentTypeName(state),
  // @ts-ignore state not yet typed
  category: getCategoryId(state),
  subcategory: getSubcategory(state),
  // @ts-ignore state not yet typed
  isPageFlaggedOrViolated: getIsContentFlaggedOrViolated(state),
  isStarterPageTemplateAndNoAdvancedFeaturesAccess:
  // @ts-ignore state not yet typed
  getIsStarterPageTemplateAndNoAdvancedFeaturesAccess(state),
  id: getContentModelId(state),
  pageLimitRequest: getPageLimitRequest(state),
  mlangPagesLimitRequest: getMlangPagesLimitRequest(state),
  shouldShowScopesHaveChangedModal: getShouldShowScopesHaveChangedModal(state),
  // @ts-ignore state not yet typed
  hasPartnerMatchingApp: getHasPartnerMatchingAppAccess(state),
  // @ts-ignore state not yet typed
  shouldHaveAddModuleSidebar: getHasAnyContainerOrDndAreaToAddModules(state),
  // @ts-ignore state not yet typed
  themePath: getThemePath(state),
  // @ts-ignore state not yet typed
  isUngatedForPatagonia: getIsUngatedForPatagonia(state),
  // @ts-ignore state not yet typed
  canUseQuickSpot: getCanUseQuickSpot(state),
  // @ts-ignore state not yet typed
  openModal: getOpenModal(state),
  // @ts-ignore state not yet typed
  hasLandingPagesMultiLangAccess: getHasLandingPagesMultiLangAccess(state),
  // @ts-ignore state not yet typed
  isPersonalizedVariant: getIsPersonalizedVariant(state),
  // @ts-ignore state not yet typed
  hasPersonalizedVariants: getHasPersonalizedVariants(state),
  isSuggested: getIsSuggested(state)
});
const PatagoniaModalSwitch = () => {
  const openModal = useSelector(getOpenModal);
  const shouldShowOnboardingModal = useSelector(state => getShouldShowOnboardingModal(state, CONSUMER_NAME));
  const runTestModalOpen = useSelector(getRunTestModalOpen);
  if (
  // @ts-ignore ONBOARDING_MODAL not yet in typed constants
  (shouldShowOnboardingModal || openModal === MODAL_TYPES.ONBOARDING_MODAL) && !isTourCurrentlyActive()) {
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        PatagoniaOnboardingTourModalContainer
      }) => {
        return /*#__PURE__*/_jsx(PatagoniaOnboardingTourModalContainer, {});
      }
    });
  }
  if (openModal === MODAL_TYPES.SETTINGS_MODAL) {
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        PatagoniaSettingsModalContainer
      }) => {
        return /*#__PURE__*/_jsx(PatagoniaSettingsModalContainer, {});
      }
    });
  }
  if (openModal === MODAL_TYPES.MLANG_LIMIT_UPGRADE_MODAL) {
    return /*#__PURE__*/_jsx(MlangLimitUpgradeModal, {});
  }
  if (runTestModalOpen) {
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        PatagoniaRunATestContainer
      }) => /*#__PURE__*/_jsx(PatagoniaRunATestContainer, {})
    });
  }
  if (openModal === MODAL_TYPES.AILP_THANK_YOU_PAGE_REMINDER) {
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        AiLpThankYouPageReminderModal
      }) => /*#__PURE__*/_jsx(AiLpThankYouPageReminderModal, {})
    });
  }
  if (openModal === MODAL_TYPES.CUSTOMER_AGENT_POST_PUBLISH) {
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        CustomerAgentPostPublishModal
      }) => /*#__PURE__*/_jsx(CustomerAgentPostPublishModal, {})
    });
  }
  if (openModal === MODAL_TYPES.CONTENT_REMIX_POST_PUBLISH) {
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        ContentRemixPostPublishModal
      }) => /*#__PURE__*/_jsx(ContentRemixPostPublishModal, {})
    });
  }
  return /*#__PURE__*/_jsx(PageOperationsModalSwitch, {
    openModalName: openModal !== null && openModal !== void 0 ? openModal : ''
  });
};
const CmsSettingsModalsWrapper = () => {
  const contentId = useSelector(getContentModelId);
  const personalizedPageUrl = usePersonalizedPageUrl({
    contentId
  });
  const contentUrl = useSelector(getPageSettingsFullUrl);
  const isStagingV2 = useSelector(getIsStagingV2);
  const sandboxDomainName = useSelector(getStagedPageSandboxDomainName);
  const finalContentUrl = useMemo(() => {
    const baseUrl = personalizedPageUrl !== null && personalizedPageUrl !== void 0 ? personalizedPageUrl : contentUrl;
    if (isStagingV2 && sandboxDomainName) {
      return buildSandboxUrl(sandboxDomainName, baseUrl);
    }
    return baseUrl;
  }, [isStagingV2, sandboxDomainName, personalizedPageUrl, contentUrl]);
  return /*#__PURE__*/_jsx(CmsSettingsModals, {
    contentUrl: finalContentUrl,
    isStaging: isStagingV2
  });
};
const mapDispatchToProps = {
  fetchCrmObjectTypes,
  fetchHubDbTables,
  fetchAccountVerificationStatus,
  fetchMultiDomainPublishingScopeChange,
  fetchBrandColors: fetchBrandColorsAction,
  fetchPageLimit: fetchPageLimitAction,
  fetchMlangPagesLimit: fetchMlangPagesLimitAction,
  autoSave: autoSaveAction,
  autoSaveDebounced: autoSaveDebouncedAction,
  fetchDataQueries,
  fetchDomainExclusionReason,
  togglePublishOptionsModalOpen: togglePublishOptionsModalOpenAction
};
class ExtraApplicationComponents extends Component {
  // TODO: Is this still needed?

  constructor(props) {
    super(props);
    this.state = {
      hasStartedTourInParentFrame: false,
      hasActiveOnboardingTour: false
    };
  }
  componentDidMount() {
    const {
      hasContentModel,
      isPageFlaggedOrViolated,
      appStatus,
      iframeReady,
      addModuleSidebarLoaded,
      isLandingPage,
      isSitePage,
      canSetDynamicPages,
      id,
      hasLandingPagesMultiLangAccess
    } = this.props;
    if (hasContentModel) {
      if (isPageFlaggedOrViolated) {
        this.redirectToDetailsPage();
        return;
      }
      this.createUsageTrackerAndTrackPageLoad();
      this.props.fetchDomainExclusionReason();
    }
    if (appStatus === APP_STATUS.READY) {
      if (iframeReady && addModuleSidebarLoaded) {
        this.triggerPostWholeAppReadyActions();
      }
    }
    this.props.fetchAccountVerificationStatus();
    this.props.fetchMultiDomainPublishingScopeChange();
    if (isLandingPage || isSitePage) {
      this.props.fetchPageLimit();
      if (id && isSitePage || isLandingPage && hasLandingPagesMultiLangAccess) {
        this.props.fetchMlangPagesLimit(id, isSitePage);
      }
    }
    if (canSetDynamicPages) {
      this.props.fetchHubDbTables();
      this.props.fetchDataQueries();
      this.props.fetchCrmObjectTypes();
    }
  }
  componentDidUpdate(prevProps) {
    const {
      hasContentModel,
      isPageFlaggedOrViolated,
      pageLimitRequest,
      mlangPagesLimitRequest,
      id,
      isLandingPage,
      isSitePage,
      addModuleSidebarLoaded,
      shouldHaveAddModuleSidebar,
      appStatus,
      iframeReady
    } = this.props;
    const isPage = isLandingPage || isSitePage;
    if (!this.state.hasActiveOnboardingTour && isTourCurrentlyActive()) {
      this.setState({
        hasActiveOnboardingTour: true
      });
    }
    if (!prevProps.hasContentModel && hasContentModel) {
      if (!prevProps.isPageFlaggedOrViolated && isPageFlaggedOrViolated) {
        this.redirectToDetailsPage();
        return;
      }
      this.createUsageTrackerAndTrackPageLoad();
      this.props.fetchDomainExclusionReason();
    }
    if (pageLimitRequest && requestFailedOrUninitialized(pageLimitRequest) && isPage) {
      this.props.fetchPageLimit();
    }
    if (mlangPagesLimitRequest && requestUninitialized(mlangPagesLimitRequest) && isPage) {
      this.props.fetchMlangPagesLimit(id, isSitePage);
    }
    const sidebarReady = addModuleSidebarLoaded || !shouldHaveAddModuleSidebar;
    const sidebarPreviouslyReady = prevProps.addModuleSidebarLoaded || !prevProps.shouldHaveAddModuleSidebar;
    const previouslyFullyReady = prevProps.appStatus === APP_STATUS.READY && prevProps.iframeReady && sidebarPreviouslyReady;
    const fullyReadyNow = appStatus === APP_STATUS.READY && iframeReady && sidebarReady;
    if (!previouslyFullyReady && fullyReadyNow) {
      this.triggerPostWholeAppReadyActions();
    }
  }
  triggerPostWholeAppReadyActions() {
    const {
      fetchBrandColors
    } = this.props;
    fetchBrandColors();
  }
  redirectToDetailsPage() {
    const {
      id,
      category,
      subcategory
    } = this.props;
    if (id && category) {
      window.location.href = ContentRoutes.details(id, category, subcategory);
    }
  }
  createUsageTrackerAndTrackPageLoad() {
    const {
      isBlogListingPage,
      isSitePage,
      themePath,
      isPersonalizedVariant,
      hasPersonalizedVariants,
      isSuggested
    } = this.props;
    const pageType = getPageType(isBlogListingPage, isSitePage);
    if (!window.jasmine) {
      const tracker = createTracker({
        events,
        properties: {
          // Required properties
          namespace: 'page-publishing',
          // Optional properties
          pageType,
          screen: `${pageType}-editor`,
          subscreen: this.props.currentPage
        },
        lastKnownEventProperties: ['screen', 'subscreen'],
        clone: true
      });
      const trackerWithSessionReplay = withSessionReplay(tracker);
      UsageTracker.init(trackerWithSessionReplay, 'page-editor-ui');
    }
    UsageTracker.track('pageLoad', {
      themePath
    });
    const originalTracker = UsageTracker.getTracker();
    const tempStandaloneTracker = originalTracker.clone({
      standalone: true
    });
    const personalizationInfo = getPersonalizationInfo({
      isSuggested,
      isPersonalizedVariant,
      hasPersonalizedVariants
    });
    tempStandaloneTracker.track('Page Publishing', 'Pageview', {
      pageType,
      screen: `${pageType}-editor`,
      subscreen: this.props.currentPage,
      personalization: personalizationInfo
    });
  }
  shouldShowBlpBetaSurvey() {
    return this.props.isBlogListingPage && !window.SELENIUM_IS_RUNNING;
  }
  shouldShowLpStarterSurvey() {
    const {
      isLandingPage,
      isStarterPageTemplateAndNoAdvancedFeaturesAccess
    } = this.props;

    // Only show the LP starter survey for landing pages created from starter templates _AND_
    // if the customer is not pro/enterprise (from account or trial)
    return isLandingPage && isStarterPageTemplateAndNoAdvancedFeaturesAccess && !window.SELENIUM_IS_RUNNING;
  }
  getSurvey() {
    if (this.shouldShowBlpBetaSurvey()) {
      return Surveys.BLP_BETA;
    } else if (this.shouldShowLpStarterSurvey()) {
      return Surveys.LP_STARTER_BETA;
    } else {
      return null;
    }
  }
  render() {
    const {
      hasPartnerMatchingApp,
      contentNounKey,
      shouldShowScopesHaveChangedModal,
      contentTypeName,
      autoSave,
      autoSaveDebounced,
      appIsReadyForSaving,
      isUngatedForPatagonia,
      canUseQuickSpot,
      openModal
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(FetchAndCorrectPageSlugContainer, {}), /*#__PURE__*/_jsx(TemplateExistenceCheckContainer, {
        contentType: contentTypeName
      }), /*#__PURE__*/_jsx(GlobalContentModal, {
        fromAppName: "pageEditor"
        // TBD: Pages / Blog use global content, but other editors may not. Prob
        // put this in extra app container ocmponents, but make blog and page both use a similar component from a seperate lib
      }), /*#__PURE__*/_jsx(EmbedModal, {
        fromAppName: "pageEditor"
      }), /*#__PURE__*/_jsx(LockedModal
      // TBD: Figure out what this does
      , {
        contentNounKey: contentNounKey
      }), hasPartnerMatchingApp && /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
        children: ({
          PartnerMatchingModalContainer
        }) => /*#__PURE__*/_jsx(PartnerMatchingModalContainer, {})
      }), /*#__PURE__*/_jsx(UpgradableModulePqls, {}), /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
        children: ({
          PageScopesHaveChangedModal
        }) => shouldShowScopesHaveChangedModal && /*#__PURE__*/_jsx(PageScopesHaveChangedModal
        // This should prob be extra app container components key
        , {})
      }), isUngatedForPatagonia && /*#__PURE__*/_jsx(PatagoniaModalSwitch, {}), /*#__PURE__*/_jsx(PatagoniaModalQueryChecker, {}), /*#__PURE__*/_jsx(CloneRequestModalContainer, {}), /*#__PURE__*/_jsx(LegacyPageScaffoldingContainer
      // Probably either refactor this out completely
      // or make it universal with config passed in
      , {}), renderFeedbackLoader(this.getSurvey()), /*#__PURE__*/_jsx(PageAutoSaveContainer, {
        autoSaveDebounced: autoSaveDebounced,
        autoSave: autoSave
        // TODO: This is some local component state currently in page application container, lots of weird was previously fully ready but now isn't checks. I wonder if we can just use a selector instead?
        ,
        isAppReadyForSaving: appIsReadyForSaving
      }), /*#__PURE__*/_jsx(CopyAsHubLContainer, {}), /*#__PURE__*/_jsx(TriggerWootricCsatSurveyContainer, {
        surveyName: WootricSurveyNames.PAGES_EDITOR
      }), /*#__PURE__*/_jsx(CmsSettingsModalsWrapper, {}), canUseQuickSpot && openModal === MODAL_TYPES.SPOTLIGHT && /*#__PURE__*/_jsx(Spotlight, {}), /*#__PURE__*/_jsx(SectionsLibraryOnboardingTourController, {}), /*#__PURE__*/_jsx(PersonalizationOnboardingBeacons, {})]
    });
  }
}
ExtraApplicationComponents.contextType = TourContext;
export default connect(mapStateToProps, mapDispatchToProps)(ExtraApplicationComponents);